<template>
  <el-select v-model="ruleForm.month" filterable :default-first-option="true">
    <el-option v-for="monthData of monthList" :key="monthData.key" :label="monthData.label"
      :value="monthData.key"></el-option>
  </el-select>
</template>
<script>
import moment from "moment";

export default {
  name: "MonthList",
  props: {
    quantity: Number,
  },
  data() {
    return {
      ruleForm: {
        month: '',
      },
      monthList: [],
    };
  },
  mounted() {
    const vm = this;
    const today = moment();
    vm.month = today.format("YYYY-MM");
    for (let i = 0; i < vm.quantity; i++) {
      vm.monthList.push({
        key: today.format("YYYY-MM"),
        label: `${today.format("MMM").toUpperCase()}/${today.format("YYYY")}`,
      });
      today.subtract(1, "month");
    }
    vm.ruleForm.month = vm.monthList[0].key;
  },
  methods: {
    get() {
      return this.ruleForm.month;
    }
  }

};
</script>
